module.exports = __webpack_public_path__ + "static/media/home.d3456438.webp";